import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Input,
  Label,
  InputGroup,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  getCategories,
  deleteCategory,
  resetCategories,
} from "../../../../store/category/actions";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { DataTable, ExportCSV, MainLoader } from "../../../../components";
import { getAll as allCategoriesExport } from "../../../../service/category";
import { selectUserRole } from "../../../../store/user/selector";
import { formatHelper } from "../../../../common/helpers";
import { roles } from "../../../../common/constants";
import MediaQuery from "react-responsive";
import { exportExcel } from "./excel";

class CategoryList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      filter: "",
      loadingExport: false,
    };
    this.handleObtainCategoriesExport =
      this.handleObtainCategoriesExport.bind(this);

    this.optionsFormatterColumn = this.optionsFormatterColumn.bind(this);
    this.handleInputFilterChange = this.handleInputFilterChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentDidMount() {
    this.performGetCategories(true);
  }

  componentDidUpdate(prevProps) {
    this.checkCategoryDelete(prevProps);
  }
  componentWillUnmount() {
    this.props.resetCategories();
  }
  performGetCategories(reset = false) {
    const { page, filter } = this.state;
    this.props.getCategories({ page, filter, reset });
  }

  async filterCategories() {
    await this.setState({ page: 1 });
    this.performGetCategories();
  }

  handleInputFilterChange(e) {
    if (e.key === "Enter") {
      this.filterCategories();
    }
  }

  async checkCategoryDelete(prevProps) {
    if (
      prevProps.deletedCategory == null &&
      this.props.deletedCategory != null
    ) {
      toast.success("Categoría eliminada satisfactoriamente");
      await this.setState({ page: 1 });
      this.performGetCategories();
    } else if (
      prevProps.deleteError == null &&
      this.props.deleteError != null
    ) {
      toast.error(this.props.deleteError);
    }
  }

  async handlePageChange(page) {
    await this.setState({ page: page });
    this.performGetCategories();
  }

  performDeleteCategory(id) {
    Swal({
      title: "Eliminar categoría",
      text: "¿Estás seguro que deseas eliminar la categoría?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.value) {
        this.props.deleteCategory(id);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }

  optionsFormatterColumn(cell, row) {
    return (
      <UncontrolledButtonDropdown>
        <DropdownToggle size="sm" color="primary">
          <i className="fa fa-bars"></i>
        </DropdownToggle>
        <DropdownMenu>
          {/* <DropdownItem onClick={() => this.props.history.push(`/administration/categories/${row.id}/detail`)} ><i className="mr-1 fa fa-eye" ></i> Detalle</DropdownItem> */}
          <DropdownItem
            onClick={() =>
              this.props.history.push(
                `/administration/categories/${row.id}/edit`
              )
            }
          >
            <i className="mr-1 fa fa-edit"></i> Editar
          </DropdownItem>
          <DropdownItem
            disabled={this.props.deleteLoading}
            onClick={() => this.performDeleteCategory(row.id)}
          >
            <i className="mr-1 fa fa-trash"></i> Eliminar
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    );
  }

  handleObtainCategoriesExport() {
    this.setState({ loadingExport: true });
    allCategoriesExport(0, null)
      .then((response) => {
        exportExcel(response.data.data);
      })
      .finally(() => {
        this.setState({ loadingExport: false });
      });
  }

  render() {
    const columnsSA = [
      {
        dataField: "name",
        text: "Nombre",
      },
      {
        dataField: "",
        text: "",
        formatter: this.optionsFormatterColumn,
        headerStyle: (colum, colIndex) => {
          return { width: "50px" };
        },
      },
    ];
    const columns = [
      {
        dataField: "name",
        text: "Nombre",
      },
    ];
    if (this.props.loading) {
      return <MainLoader />;
    }
    return (
      <div className="animated">
        <Card>
          <CardHeader>
            <i className="icon-list"></i>Categorías
          </CardHeader>
          <CardBody>
            <MediaQuery minDeviceWidth={600}>
              {(matches) => {
                if (matches) {
                  return (
                    <Row className="mb-2">
                      <Col sm="8">
                        <InputGroup>
                          <Input
                            type="text"
                            id="input1-group2"
                            name="input1-group2"
                            placeholder="Buscar"
                            value={this.state.filter}
                            onChange={(e) =>
                              this.setState({ filter: e.target.value })
                            }
                            onKeyPress={this.handleInputFilterChange}
                          />
                          <div className="input-group-prepend">
                            <Button
                              type="button"
                              color="primary"
                              onClick={() => this.filterCategories()}
                            >
                              <i className="fa fa-search"></i>
                            </Button>
                          </div>
                        </InputGroup>
                      </Col>

                      <Col sm="4">
                        <ExportCSV
                          disabled={this.state.loadingExport}
                          exportCSV={this.handleObtainCategoriesExport}
                        />
                      </Col>
                    </Row>
                  );
                } else {
                  return (
                    <Row className="mb-2">
                      <Col md="10">
                        <InputGroup>
                          <Input
                            type="text"
                            id="input1-group2"
                            name="input1-group2"
                            placeholder="Buscar"
                            value={this.state.filter}
                            onChange={(e) =>
                              this.setState({ filter: e.target.value })
                            }
                            onKeyPress={this.handleInputFilterChange}
                          />
                          <div className="input-group-prepend">
                            <Button
                              type="button"
                              color="primary"
                              onClick={() => this.filterCategories()}
                            >
                              <i className="fa fa-search"></i>
                            </Button>
                          </div>
                        </InputGroup>
                      </Col>

                      <Col md="2">
                        <ExportCSV
                          disabled={this.state.loadingExport}
                          exportCSV={this.handleObtainCategoriesExport}
                        />
                      </Col>
                    </Row>
                  );
                }
              }}
            </MediaQuery>
            <hr className="my-4" />
            {this.props.role == roles.SUPER_ADMIN && (
              <Row className="mb-2">
                <Col>
                  <div className="float-right">
                    <Button
                      color="primary"
                      onClick={() =>
                        this.props.history.push(
                          "/administration/categories/add"
                        )
                      }
                    >
                      <i className="mr-1 fa fa-plus"></i> Nuevo
                    </Button>
                  </div>
                </Col>
              </Row>
            )}
            <Row>
              <Col>
                <DataTable
                  data={this.props.categories}
                  keyField="id"
                  columns={
                    this.props.role == roles.SUPER_ADMIN ? columnsSA : columns
                  }
                  page={this.state.page}
                  totalSize={this.props.total}
                  sizePerPage={this.props.pageSize}
                  loading={this.props.loading}
                  onPageChange={this.handlePageChange}
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { categories, error, loading, pageSize, total } =
    state.category.categoryList;

  return {
    categories,
    error,
    loading,
    pageSize,
    total,
    deletedCategory: state.category.deleteCategory.category,
    deleteError: state.category.deleteCategory.error,
    deleteLoading: state.category.deleteCategory.loading,
    role: selectUserRole(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getCategories,
      deleteCategory,
      resetCategories,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryList);



// WEBPACK FOOTER //
// ./src/scenes/Administration/Category/CategoryList/CategoryList.js